import React from 'react';
import {arrayOf, func, shape, string} from 'prop-types';
import {Toggle, ToggleGroup} from '@sabre/spark-react-core';
import {map} from 'lodash';

const DashboardTopTabs = ({dashboardTopTabDetails, dashboardTopTabOnClickHandler}) => {
    return (
        <ToggleGroup
            className={dashboardTopTabDetails.className || ''}
            name={dashboardTopTabDetails.toggleName}
            role='group'
            onChange={dashboardTopTabOnClickHandler}
        >
            {
                map(dashboardTopTabDetails.toggle, (toggleDetails, tIndex) =>
                    <Toggle
                        key={`${toggleDetails.toggleValue.replace(/\s+/ig, '-').toLowerCase()}-${tIndex}`}
                        defaultChecked={tIndex === 0}
                        label={toggleDetails.toggleLabel}
                        value={toggleDetails.toggleValue}
                    />
                )
            }
        </ToggleGroup>
    );
};

DashboardTopTabs.propTypes = {
    dashboardTopTabDetails: shape({
        toggleName: string.isRequired,
        className: string,
        toggle: arrayOf(
            shape({
                toggleLabel: string.isRequired,
                toggleValue: string.isRequired,
                className: string
            })).isRequired,
    }),
    dashboardTopTabOnClickHandler: func.isRequired
};

export default DashboardTopTabs;
